export default __webpack_public_path__ + "e8fe9b6.png";